/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

function updateWishlistCount() {

    var wishlistCountBubble = document.querySelector("[data-wishlist-count-bubble]");
    var wishlistCount = document.querySelector("[data-wishlist-count]");
    if(wishlistCountBubble && wishlistCount) {
        _swat.fetchWrtEventTypeET(
            function (wishlistProducts) {
                var wishlistCountLength = wishlistProducts.length;
                if (wishlistCountLength > 0) {
                    wishlistCount.innerHTML = wishlistCountLength;
                    wishlistCountBubble.classList.remove("hide");
                } else {
                    wishlistCountBubble.classList.add("hide");
                }
            }
        );
    }
}

function swymCallbackFnLoadCount() {
    var wishlistCountBubble = document.querySelector("[data-wishlist-count-bubble]");
    var wishlistCount = document.querySelector("[data-wishlist-count]");

    if(wishlistCountBubble && wishlistCount) {
        window._swat.fetchWrtEventTypeET(
            function (wishlistProducts) {
                var wishlistCountLength = wishlistProducts.length;
                if (wishlistCountLength > 0) {
                    wishlistCount.innerHTML = wishlistCountLength;
                    wishlistCountBubble.classList.remove("hide");
                }
            }
        );
    }
}

if(!window.SwymCallbacks){
    window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFnLoadCount);


// js/helper/currency.js
function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
        cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
        return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultTo(precision, 2);
        thousands = defaultTo(thousands, ",");
        decimal = defaultTo(decimal, ".");
        if (isNaN(number) || number == null) {
            return 0;
        }
        number = (number / 100).toFixed(precision);
        let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
        return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
        case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
        case "amount_with_space_separator":
            value = formatWithDelimiters(cents, 2, " ", ".");
            break;
        case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
        case "amount_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 2, "'", ".");
            break;
        case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
        case "amount_no_decimals_with_space_separator":
            value = formatWithDelimiters(cents, 0, " ");
            break;
        case "amount_no_decimals_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 0, "'");
            break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
        return formatString.replace(placeholderRegex, value);
    } else {
        return formatString.replace(placeholderRegex, value);
    }
}

document.addEventListener('variant:changed', function(event) {
    let variant = event.detail.variant; // Gives you access to the whole variant details
    let premium_sample_product_colour = document.getElementById('premium-sample-product-colour');
    let free_sample_product_colour = document.getElementById('free-sample-product-colour');
    let sample_product_colour = document.getElementById('sample-product-colour');
    if(variant.option3 && premium_sample_product_colour) {
        premium_sample_product_colour.value = variant.option3;
    }
    if(variant.option3 && free_sample_product_colour) {
        free_sample_product_colour.value = variant.option3;
    }
    if(variant.option3 && sample_product_colour) {
        sample_product_colour.value = variant.option3;
    }
});

document.addEventListener('variant:changed', function(event) {
   let variant = event.detail.variant; // Gives you access to the whole variant details
   let form = event.target;
    let productPrices = this.querySelector("[data-product-price-list]"), currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
    if (!productPrices) {
        return;
    }
    let productType = document.getElementById('product-type');
    let productPriceBreakType = document.getElementById('product-price-break-type');
    if (!productType) {
        return;
    }
    let currency = window.themeVariables.settings.cartCurrency;
    let multiplier = 1;
    let length = 1;
    if(currency == 'GBP' && !window.themeVariables.customer.is_b2b) {
        multiplier = multiplier * 1.2;
    }



    if (!variant) {
        productPrices.style.display = "none";
    } else {

        let unit = '';
        let unit_with_slash = '';
        let qty_unit= document.getElementById('qty-unit');

        if(window.themeVariables.strings.productPbtMetre.includes(productPriceBreakType.value)) {

            unit = productPriceBreakType.value.toLowerCase();

            if (currency == 'USD') {
                unit = 'yard';
            }

            unit_with_slash = ' / ' + unit;

            if (variant['option2'] != window.themeVariables.strings.productCutLength) {

                let str = variant['option2'];
                let lengths_array = str.split("/");

                qty_unit.innerHTML = '';

                if (lengths_array.length == 2) {
                    let length_met = lengths_array[0].replace(',', '.');
                    let length_imp = lengths_array[1].replace(',', '.');
                    length_met = length_met.match(/[+-]?\d+(\.\d+)?/g);
                    length_imp = length_imp.match(/[+-]?\d+(\.\d+)?/g);
                    if (currency == 'USD') {
                        length = length_imp;
                    } else {
                        length = length_met;
                    }
                }

                let ppm = formatMoney((Math.floor(variant['price'] / length)) * multiplier, currencyFormat);
                //unit_with_slash = ' (approx ' + ppm + ' / ' + unit + ')';
                unit_with_slash = ' (' + ppm + ' / ' + unit + ')';

            } else {
                qty_unit.innerHTML = unit + '(s)';
            }

        } else if ( window.themeVariables.strings.productPbtPair.includes(productPriceBreakType.value) ||
                    window.themeVariables.strings.productPbtPiece.includes(productPriceBreakType.value) ||
                    window.themeVariables.strings.productPbtBag.includes(productPriceBreakType.value)) {

            unit = productPriceBreakType.value.toLowerCase();
            unit_with_slash = ' / ' + unit;
            let str = variant['option2'];
            length = str.match(/[+-]?\d+(\.\d+)?/g);

            if (!str.startsWith('1 ')) {
                let ppm = formatMoney((Math.floor(variant['price'] / length)) * multiplier, currencyFormat);
                //unit_with_slash = ' (approx ' + ppm + ' / ' + unit + ')';
                unit_with_slash = ' (' + ppm + ' / ' + unit + ')';
            }

        }

        let price = formatMoney(variant["price"] * multiplier, currencyFormat);
        let compare_at_price = formatMoney(variant["compare_at_price"] * multiplier, currencyFormat);

        productPrices.innerHTML = "";
        if (variant["compare_at_price"] > variant["price"]) {
            productPrices.innerHTML += `<span class="price price--highlight price--large"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${price} ${unit_with_slash}</span>`;
            productPrices.innerHTML += `<span class="price price--compare"><span class="visually-hidden">${window.themeVariables.strings.productRegularPrice}</span>${compare_at_price}</span>`;
        } else {
            productPrices.innerHTML += `<span class="price price--large"><span class="visually-hidden">${window.themeVariables.strings.productRegularPrice}</span>${price} ${unit_with_slash}</span>`;
        }
        productPrices.style.display = "";

    }
});

document.addEventListener('cart:updated', function(event) {
    var cart = event.detail.cart; // Get the updated content of the cart

    // Whenever cart is updated, check for sample free / paid forms, hide the relevent ones.
    if(document.getElementById('free-sample-form') && document.getElementById('paid-sample-form')) {

        let freeSampleCount = 0;
        let freeSampleSku = 'sample-free';

        for (item in cart.items) {
            if(cart.items[item]['handle'] == freeSampleSku) {
                freeSampleCount = freeSampleCount + cart.items[item]['quantity'];
            }
        }

        if(freeSampleCount > 1) {
            document.getElementById('free-sample-form').classList.add('hidden-all');
            document.getElementById('paid-sample-form').classList.remove('hidden-all');
        } else {
            document.getElementById('free-sample-form').classList.remove('hidden-all');
            document.getElementById('paid-sample-form').classList.add('hidden-all');
        }
    }
});